<p>gps-geo-marker-dialog works!</p>
